import Swal from "sweetalert2";
import backendApi from "./api";
import { t } from "i18next";

class PopupService {
    public readonly swal: typeof Swal;

    constructor() {
        this.swal = Swal.mixin({
            allowEscapeKey: false,
            allowOutsideClick: false,
        });
    }

    public showApiError(ex: unknown) {
        const [errorMessage, type] = backendApi.getFirstError(ex);
        if (type === 1) {
            const title = t("validation.error");
            return this.swal.fire({ title: title, text: errorMessage, icon: "error" });
        } else {
            const title = t("validation.warning");
            return this.swal.fire({ title: title, text: errorMessage, icon: "warning" });
        }
    }

    public showWarning(text: string, html?: string) {
        return this.swal.fire({ icon: "warning", text: text, html: html });
    }

    public showSuccess(text: string) {
        return this.swal.fire({ icon: "success", text: text });
    }

    public showError(text: string) {
        return this.swal.fire({ icon: "error", text: text });
    }

    public showConfirm(text: string, html?: string) {
        const yesButton = t("forms.Yes");
        const noButton = t("forms.No");

        return this.swal.fire({
            icon: "warning",
            text: text,
            html: html,
            showCancelButton: true,
            confirmButtonText: yesButton,
            cancelButtonText: noButton,
        });
    }

    public downloadFile(text: string, fileUrl: string) {
        const yesButton = t("forms.Yes");
        const noButton = t("forms.No");

        const html = `
        <div>
            <p>${text}</p>
            <a href="${fileUrl}" id="custom-download-button" class="swal2-confirm swal2-styled" target="_blank" rel="noreferrer" style="font-size: 14px; border-radius: 6px; text-decoration: unset;">
                ${yesButton}
            </a>
            <button type="button" id="custom-cancel-button" class="swal2-cancel swal2-styled">
                ${noButton}
            </button>
        </div>
    `;

        this.swal.fire({
            icon: "warning",
            html: html,
            showCancelButton: false, // Hide the default buttons
            showConfirmButton: false,
            didOpen: () => {
                document.getElementById("custom-cancel-button")?.addEventListener("click", () => {
                    this.swal.close();
                });
                document.getElementById("custom-download-button")?.addEventListener("click", () => {
                    this.swal.close();
                });
            },
        });
    }

    public showLoading() {
        this.swal.fire();
        this.swal.showLoading(null);
    }

    public close() {
        this.swal.close();
    }

    public wantDiscard(text: string) {
        const cancelButton = t("button.cancel");
        const discardButton = t("button.discard");
        return this.swal.fire({
            text: text,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: discardButton,
            cancelButtonText: cancelButton,
            confirmButtonColor: "#dc3545",
        });
    }
}

export default new PopupService();
